import { render } from "./DuyetDeTai.vue?vue&type=template&id=4ac9741d&scoped=true&ts=true"
import script from "./DuyetDeTai.vue?vue&type=script&lang=ts"
export * from "./DuyetDeTai.vue?vue&type=script&lang=ts"

import "./DuyetDeTai.vue?vue&type=style&index=0&id=4ac9741d&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/NghienCuuKhoaHoc/NCKH_FontEnd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac9741d"]])

export default __exports__